import React from "react";

import IconButton from "components/IconButton";

import addIcon from "components/assets/images/school_money/item-add.svg";

export default class AddButton extends React.Component {
  
  render() {
    return (
      <IconButton src={addIcon} {...this.props} />
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/AddButton.js